import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { merchantAsync } from "../actions/Merchant.action";
import { IMerchantState } from "models/Slices/merchantSlice.model";
import { IChoiceMerchant } from "models/Login/choiceMerchant.model";

const initialState: IMerchantState = {
  merchant: null,
  selectedMerchant: "",
  loading: false,
  error: "",
  success: false,
};

export const merchantSlice = createSlice({
  name: "merchant",
  initialState,
  reducers: {
    resetMerchant: (state) => {
      state.success = false;
      state.loading = false;
      state.merchant = null;
      state.selectedMerchant = "";
    },
    resetMerchantError: (state) => {
      state.error = "";
    },
    setMerchantError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    sendMerchant: (state, action: PayloadAction<string>) => {
      state.selectedMerchant = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(merchantAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        merchantAsync.fulfilled,
        (state, action: PayloadAction<IChoiceMerchant>) => {
          state.loading = false;
          state.merchant = action.payload;
          state.success = state.merchant?.Merchants?.length > 0 ? true : false;
        }
      )
      .addCase(merchantAsync.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
        state.success = false;
      });
  },
});

export const {
  resetMerchant,
  sendMerchant,
  resetMerchantError,
  setMerchantError,
} = merchantSlice.actions;

export const selectSuccess = (state: RootState) => state.merchant.success;
export const selectMerchant = (state: RootState) =>
  state.merchant.selectedMerchant;

export default merchantSlice.reducer;
